import React from "react";
import { Box } from "theme-ui";
import "../styles.scss";

import {
  getDefaultProps,
  KameleonElement,
  tertiaryBlock,
  TertiaryBlockConfig,
  TertiaryBlockSize,
} from "@kameleon-core/lib";
import { Variants } from "@kameleon-util/global-theme";
import blockinfo from "./blockinfo.json";
import defaults from "./defaults.json";
import { TextType } from "./types/prop-types";

/** Text section */
const blockConfig: TertiaryBlockConfig = {
  blockSize: TertiaryBlockSize.Default,
};

const Text = tertiaryBlock<TextType>(
  blockConfig,
  ({ leftText, rightText, link, linkText }: TextType) => (
    <Box className="section-text-v1 text-animation">
      <Variants.AnimationTertiary>
        <Box className="margin-top">
          {leftText && (
            <Variants.ParagraphSmall className="inline">
              {leftText}{" "}
            </Variants.ParagraphSmall>
          )}
          {linkText && (
            <Variants.ParagraphSmall className="inline">
              <Variants.LinkUnderline href={link}>
                {linkText}
              </Variants.LinkUnderline>
            </Variants.ParagraphSmall>
          )}
          {rightText && (
            <Variants.ParagraphSmall className="inline">
              {" "}
              {rightText}
            </Variants.ParagraphSmall>
          )}
        </Box>
      </Variants.AnimationTertiary>
    </Box>
  )
);

Text.defaultProps = getDefaultProps<TextType>(defaults);

export const Element: KameleonElement = {
  component: Text,
  blockInfo: blockinfo,
  defaultProps: {
    layoutProps: defaults.layoutProps,
    contentProps: defaults.contentProps,
  },
  layoutOptions: {},
};
